/**
 * Re-export da lib pricing do `@infomatic/shared` com renames retrocompatíveis.
 *
 * A lib agora vive em shared/ pra que backend e frontend usem a mesma função
 * (ver shared/src/pricing-calc.ts). Aqui mantemos os nomes antigos usados
 * pelo form de nova proposta (`AddOns`, `Inventario`, `Breakdown`, etc.).
 */

import {
  calcularPricing as calcularPricingShared,
  calcularOnboardingSugerido as calcularOnboardingSugeridoShared,
  ADDONS_PRICING_VAZIO,
  INVENTARIO_PRICING_VAZIO,
  type AddOnsPricing,
  type BreakdownPricing,
  type InputCalculoPricing,
  type InventarioPricing,
  type LinhaBreakdown as LinhaBreakdownShared,
  type OnboardingInput as OnboardingInputShared,
  type OnboardingKey as OnboardingKeyShared,
  type OnboardingSugerido as OnboardingSugeridoShared,
  type PacoteKey as PacoteKeyShared,
  type PerfilKey as PerfilKeyShared,
  type RecursosPricing,
} from '@infomatic/shared';

export type LinhaBreakdown = LinhaBreakdownShared;

// Renames pra manter compatibilidade com o código existente
export type PacoteKey = PacoteKeyShared;
export type PerfilKey = PerfilKeyShared;
export type OnboardingKey = OnboardingKeyShared;
export type Recursos = RecursosPricing;
export type Inventario = InventarioPricing;
export type AddOns = AddOnsPricing;
export type Breakdown = BreakdownPricing;
export type InputCalculo = InputCalculoPricing;

export const ADDONS_VAZIO: AddOns = ADDONS_PRICING_VAZIO;
export const INVENTARIO_VAZIO: Inventario = INVENTARIO_PRICING_VAZIO;

export type OnboardingInput = OnboardingInputShared;
export type OnboardingSugerido = OnboardingSugeridoShared;

export { calcularPricingShared as calcularPricing };
export { calcularOnboardingSugeridoShared as calcularOnboardingSugerido };

export function fmtBRL(n: number): string {
  return n.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
